module.exports = __webpack_public_path__ + "static/media/MFSL.4925dd64.txt";